import React from "react";

const SearchIcon = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 23 23"
    height="21"
    width="21"
  >
    <g transform="translate(1 1)">
      <g fillRule="evenodd" fill="none" id="Dashboard-/-Search_1551976184985">
        <g
          strokeWidth="2"
          stroke="#6E727E"
          transform="translate(-130 -219)"
          id="Dashboard_1551976184985"
        >
          <g transform="translate(106 195)" id="search-container_1551976184985">
            <g transform="translate(24 24)" id="search-field_selected_1551976184985">
              <g id="search_icon_1551976184985">
                <circle
                  r="7"
                  cy="8"
                  cx="8"
                  transform="matrix(-1 0 0 1 16 0)"
                  id="Oval-2_1551976184985"
                  vectorEffect="non-scaling-stroke"
                />
                <path
                  transform="matrix(-1 0 0 1 32.441 0)"
                  strokeLinecap="round"
                  id="Line_1551976184985"
                  d="M19.4026573,13.0386963 L13.0386963,19.4026573"
                  vectorEffect="non-scaling-stroke"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SearchIcon;
